import * as timePeriods from '@/constants/time_periods';

export default {
  data() {
    return {
      useNullablePeriod: false,
    };
  },
  computed: {
    periodItems() {
      const items = [];
      if (this.useNullablePeriod) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.values(timePeriods)
        .forEach(period => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.periods.${period}`),
            value: period,
          });
        });
      return items;
    },
  },
};
